/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestImportFromJsonUrlMutationVariables = Types.Exact<{
  input: Types.RequestImportFromJsonUrlInput;
}>;


export type RequestImportFromJsonUrlMutation = { requestImportFromJsonUrl: { __typename: 'RequestUploadUrlResult', uploadUrl: string } };


export const RequestImportFromJsonUrlDocument = gql`
    mutation RequestImportFromJsonUrl($input: RequestImportFromJsonUrlInput!) {
  requestImportFromJsonUrl(input: $input) {
    uploadUrl
  }
}
    `;
export type RequestImportFromJsonUrlMutationFn = Apollo.MutationFunction<RequestImportFromJsonUrlMutation, RequestImportFromJsonUrlMutationVariables>;

/**
 * __useRequestImportFromJsonUrlMutation__
 *
 * To run a mutation, you first call `useRequestImportFromJsonUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestImportFromJsonUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestImportFromJsonUrlMutation, { data, loading, error }] = useRequestImportFromJsonUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestImportFromJsonUrlMutation(baseOptions?: Apollo.MutationHookOptions<RequestImportFromJsonUrlMutation, RequestImportFromJsonUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestImportFromJsonUrlMutation, RequestImportFromJsonUrlMutationVariables>(RequestImportFromJsonUrlDocument, options);
      }
export type RequestImportFromJsonUrlMutationHookResult = ReturnType<typeof useRequestImportFromJsonUrlMutation>;
export type RequestImportFromJsonUrlMutationResult = Apollo.MutationResult<RequestImportFromJsonUrlMutation>;
export type RequestImportFromJsonUrlMutationOptions = Apollo.BaseMutationOptions<RequestImportFromJsonUrlMutation, RequestImportFromJsonUrlMutationVariables>;